/**
 * Rótulos legíveis por `eventType` (todos os `EntityEvent` do Sales). Um lugar
 * só: a timeline da aba Auditoria e o histórico dos alertas na Central de
 * Pendências (`alerts-pending-source.ts`) falam o mesmo vocabulário.
 */
const EVENT_LABEL: Record<string, string> = {
  // Contract
  CONTRACT_CREATED: 'Contrato criado',
  CONTRACT_STATUS_CHANGED: 'Status do contrato alterado',
  CONTRACT_BILLING_AGREEMENT_CHANGED: 'BA atual do contrato alterada',
  CONTRACT_MERGED: 'Contrato mesclado',
  CONTRACT_ABANDONED: 'Contrato abandonado',
  // Billing Agreement
  BA_CREATED: 'Billing Agreement criada',
  BA_STATUS_CHANGED: 'Status da BA alterado',
  BA_REPLACES_SET: 'Vínculo de substituição definido',
  BA_MOVED_TO_CONTRACT: 'BA movida de contrato',
  // Explica por que a "Fatura 7" de ontem é a "Fatura 9" de hoje: a
  // reconciliação renumerou as faturas pela ordem de período, sem que nada
  // tivesse sido cobrado.
  BA_CYCLES_RENUMBERED: 'Ciclos da BA renumerados por período',
  BA_CANCEL_REQUESTED: 'Cancelamento de BA solicitado',
  BA_CHAIN_LINKED: 'Cadeia de BAs vinculada',
  // Invoice
  INVOICE_CREATED: 'Invoice criada',
  INVOICE_STATUS_CHANGED: 'Status da invoice alterado',
  // Debt Arrangement
  DA_CREATED: 'Renegociação criada',
  DA_ACTIVATED: 'Renegociação ativada',
  DA_ACTIVATED_BY_PAYMENT: 'Renegociação ativada (1º pagamento)',
  DA_BROKEN_BY_PASTDUE: 'Renegociação quebrada (atraso)',
  DA_COMPLETED_BY_EXPIRY: 'Renegociação concluída',
  DA_CANCELLED: 'Renegociação cancelada',
  DA_REVERTED: 'Renegociação revertida',
  // Transaction
  TRANSACTION_CREATED: 'Transação criada',
  TRANSACTION_STATUS_CHANGED: 'Status da transação alterado',
  TRANSACTION_INVALIDATED: 'Lançamento manual anulado',
  // Baixa manual. Os `INCONSISTENCY_*` são o histórico de quando o pagamento
  // duplicado era uma fila própria — o alerta migrado os mostra pelo mesmo id.
  INVOICE_MANUALLY_SETTLED: 'Fatura baixada manualmente',
  INCONSISTENCY_DETECTED: 'Inconsistência detectada',
  INCONSISTENCY_RESOLVED: 'Inconsistência resolvida',
  INCONSISTENCY_DISMISSED: 'Inconsistência descartada',
  // Operações de inbox / conferência de ciclos
  WEBHOOK_INBOX_FORCE_PROCESSED: 'Webhook reprocessado à força',
  BA_CYCLE_COUNT_RESOLVED: 'Contagem de ciclos da BA resolvida',
  BA_CHARGE_HISTORY_AUDITED: 'Histórico de cobranças auditado',
  // Alertas operacionais (`SalesAlerts`)
  ALERT_OPENED: 'Alerta aberto',
  ALERT_RESOLVED: 'Alerta resolvido',
  ALERT_DISMISSED: 'Alerta descartado',
  ALERT_REOPENED_FOR_ENTITY: 'Voltou a abrir alerta para a entidade',
};

/** `eventType` sem rótulo aparece cru: o back pode ganhar um tipo antes daqui. */
export function eventLabel(eventType: string): string {
  return EVENT_LABEL[eventType] ?? eventType;
}
